export const reviews = [
  {
    id: "review-1",
    text: "Compré dos juegos increíbles y nos explicaron cómo jugarlos. ¡Qué bien que traigan de vuelta los juegos de mesa!",
    author: "Visitante de Google",
  },
  {
    id: "review-2",
    text: "El lugar es muy bonito, los productos y los juegos son súper interesantes y la atención es excelente.",
    author: "Visitante de Google",
  },
  {
    id: "review-3",
    text: "Tienen muchísima variedad de juegos de mesa para toda la familia. La atención, de diez.",
    author: "Visitante de Google",
  },
];